import type { PodBadgeStyle } from "./PodPrintingType";

export enum PodOrderProgressStage {
  LEAD = "LEAD",
  PROJECT_CREATED = "PROJECT_CREATED",
  UNASSIGNED = "UNASSIGNED",
  INVENTORY_ALLOCATED = "INVENTORY_ALLOCATED",
  OUT_FOR_PRINTING = "OUT_FOR_PRINTING",
  PARTIALLY_PRINT_INWARD = "PARTIALLY_PRINT_INWARD",
  PRINT_INWARD_COMPLETE = "PRINT_INWARD_COMPLETE",
  SHIPMENT_CREATED = "SHIPMENT_CREATED",
  SHIPMENT_SHIPPED = "SHIPMENT_SHIPPED",
}

const STAGE_TEXT_COLOR = "#FFFFFF";

const POD_ORDER_PROGRESS_STAGE_BADGE: Record<PodOrderProgressStage, PodBadgeStyle> = {
  [PodOrderProgressStage.LEAD]: { label: "Lead", color: STAGE_TEXT_COLOR, backgroundColor: "#6B7280" },
  [PodOrderProgressStage.PROJECT_CREATED]: { label: "Project Created", color: STAGE_TEXT_COLOR, backgroundColor: "#2563EB" },
  [PodOrderProgressStage.UNASSIGNED]: { label: "Unassigned", color: STAGE_TEXT_COLOR, backgroundColor: "#3B82F6" },
  [PodOrderProgressStage.INVENTORY_ALLOCATED]: { label: "Allocation", color: STAGE_TEXT_COLOR, backgroundColor: "#3B82F6" },
  [PodOrderProgressStage.OUT_FOR_PRINTING]: { label: "Print Outward", color: STAGE_TEXT_COLOR, backgroundColor: "#DB2777" },
  [PodOrderProgressStage.PARTIALLY_PRINT_INWARD]: { label: "Partially Print Inward", color: STAGE_TEXT_COLOR, backgroundColor: "#059669" },
  [PodOrderProgressStage.PRINT_INWARD_COMPLETE]: { label: "Print Inward Complete", color: STAGE_TEXT_COLOR, backgroundColor: "#008000" },
  [PodOrderProgressStage.SHIPMENT_CREATED]: { label: "Shipment Created", color: STAGE_TEXT_COLOR, backgroundColor: "#D97706" },
  [PodOrderProgressStage.SHIPMENT_SHIPPED]: { label: "Shipped", color: STAGE_TEXT_COLOR, backgroundColor: "#0F766E" },
};

/** UI labels for filters, tabs, etc. */
export const POD_ORDER_PROGRESS_STAGE_LABELS = Object.fromEntries(
  Object.entries(POD_ORDER_PROGRESS_STAGE_BADGE).map(([key, style]) => [key, style.label]),
) as Record<PodOrderProgressStage, string>;

const POD_ORDER_ALLOCATED_ONWARDS_STAGES = new Set<string>([
  PodOrderProgressStage.INVENTORY_ALLOCATED,
  PodOrderProgressStage.OUT_FOR_PRINTING,
  PodOrderProgressStage.PARTIALLY_PRINT_INWARD,
  PodOrderProgressStage.PRINT_INWARD_COMPLETE,
  PodOrderProgressStage.SHIPMENT_CREATED,
  PodOrderProgressStage.SHIPMENT_SHIPPED,
]);

export const isPodOrderAllocatedStage = (stage?: string | null): boolean =>
  Boolean(stage && POD_ORDER_ALLOCATED_ONWARDS_STAGES.has(stage));

export const getPodOrderProgressStageBadgeStyle = (stage?: string | null): PodBadgeStyle => {
  if (stage && stage in POD_ORDER_PROGRESS_STAGE_BADGE) {
    return POD_ORDER_PROGRESS_STAGE_BADGE[stage as PodOrderProgressStage];
  }
  if (!stage) {
    return { label: "—", color: STAGE_TEXT_COLOR, backgroundColor: "#6B7280" };
  }
  return { label: stage.replace(/_/g, " "), color: STAGE_TEXT_COLOR, backgroundColor: "#6B7280" };
};
